import api from '../../utils/api'

const API_BASE_URL = "/geo/GEOCtry";

const GEOCtryService = {
  async findAll(): Promise<any> {
    const response = await api.get(`${API_BASE_URL}/find-all`);
    return response.data;
  },

  async getItemById(countryCode: string): Promise<any> {
    const response = await api.get(`${API_BASE_URL}/find-one/${countryCode}`);
    return response.data;
  },

  async create(item: any): Promise<any> {
    const response = await api.post(`${API_BASE_URL}/create`, item);
    return response.data;
  },

  async update(countryCode: string, item: any): Promise<any> {
    const response = await api.put(`${API_BASE_URL}/update/${countryCode}`, item);
    return response.data;
  },

  async delete(countryCode: string): Promise<any> {
    const response = await api.delete(`${API_BASE_URL}/delete/${countryCode}`);
    return response.data;
  },

  async getCountryDropdown(): Promise<any> {
    const response = await api.get(`${API_BASE_URL}/get-dropdown`);
    return response.data;
  },
};

export default GEOCtryService;